import { render } from "./Loading.vue?vue&type=template&id=502f31fa&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=502f31fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502f31fa"]])

export default __exports__